export default {"src":"/_next/static/media/separator-bottom.bead8cc5.svg","height":61,"width":1200,"blurWidth":0,"blurHeight":0};